import { autoType } from "d3";
import React, { FC } from "react";
import { Dropdown } from "react-bootstrap";

interface Props {
    header: string;
    choices: string[];
    updateSelection: (newSelection: string) => void;
}

export const SimpleDropdown: FC<Props> = ({
    header,
    choices,
    updateSelection
}) => {
    const generateAlternatives = choices.map(
        (choice: string, index: number) => (
            <Dropdown.Item
                key={index}
                eventKey={index.toString()}
                onClick={() => updateSelection(choice)}
            >
                {choice}
            </Dropdown.Item>
        )
    );

    return (
        <Dropdown align="end">
            <Dropdown.Toggle
                id="user-dropdown"
                style={{
                    maxWidth: "400px",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                }}
            >
                {header}
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ maxHeight: "400px", overflowY: "auto" }}>
                {generateAlternatives}
            </Dropdown.Menu>
        </Dropdown>
    );
};
